/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const PowDifficultySettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('POW_DIFFICULTY')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecNumber)],
]);
export class PowDifficultySetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PowDifficultySettingParser.decode(input).map(res => new PowDifficultySetting(res));
    }
    static unsafeDecode(input) {
        return PowDifficultySetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PowDifficultySettingParser.encode(data);
    }
    static schema() {
        return PowDifficultySettingParser.schema();
    }
}
